import { saveTemplate } from "../../../utils/truInkTemplate";
import { v4 as uuidv4 } from "uuid";
export const templateHandleFunctions = (
  formData,
  setFormData,
  truInkState,
  tenantId,
  siteId,
  canvasSizes,
  canvasColors,
  setIsSaving,
  setError,
  navigate,
  onClose,
  rotation
) => {
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleConfirm = async () => {
    sessionStorage.setItem("currentState", JSON.stringify(truInkState));
    if (!tenantId || !siteId) {
      setError("Tenant ID and Site ID are required");
      alert("Tenant ID and Site ID are required to create a template");
      return;
    }

    if (!formData.templateName.trim()) {
      setError("Template name is required");
      return;
    }

    if (!formData.screenSize) {
      setError("Screen size is required");
      return;
    }

    if (!formData.selectableColor) {
      setError("Selectable color is required");
      return;
    }

    setIsSaving(true);
    setError(null);

    try {
      const templateId = uuidv4();
      const selectedSize = canvasSizes.find(size => size.resolution === formData.screenSize);
      const selectedColor = canvasColors.find(color => color.id === formData.selectableColor);
      const templateData = {
        id: templateId,
        name: formData.templateName.trim(),
        screenSize: formData.screenSize,
        selectableColor: formData.selectableColor,
        ...(selectedSize && {
          canvasSizeId: selectedSize.id,
          canvasWidth: selectedSize.width,
          canvasHeight: selectedSize.height
        }),
        ...(selectedColor && {
          canvasColorId: selectedColor.id,
          canvasColorName: selectedColor.name
        }),
        customProperties: {
          truInkEMMSTemplate: formData.truInkEMMSTemplate,
          rotation: rotation,
          mode:formData.customProperties?.mode || "landscape"
        }
      };

      const response = await saveTemplate(templateData, tenantId, siteId);

      navigate(`/${templateId}`);
    } catch (error) {
      console.error("Error saving template:", error);
      setError(error.message || "Failed to save template");
      alert(`Error saving template: ${error.message}`);
    } finally {
      setIsSaving(false);
      onClose();
    }
  };
  return { handleChange, handleConfirm };
};
